.numberPage {
  position: relative;
  z-index: 1;
  /* Edge + chrome clearance is handled by the live stage safe-area
   * (--token-safe-*); the page fills its safe box. */
  padding: 0;
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
  /* 100% (NOT 100vh) so the section fills the KioskStage's 1080-design
   * height. Using 100vh ties the section to the real viewport, which
   * is shorter than 1080 on letterboxed displays and prevents
   * justify-content: center from having room to work. */
  min-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* Vertically + horizontally centers the header + card stack within
   * the page so shorter content sits in the middle of the viewport. */
  justify-content: center;
  align-items: center;
  gap: var(--token-space-sm);
}

/* Fixed DESIGN width so the card's internal layout never reflows with the
 * viewport (the two columns + the expanded-form row stay put). useFitScale
 * then shrinks the whole card uniformly to fit narrow/short displays — so the
 * page scales as one unit instead of wrapping its contents. */
.numberPage > .card {
  width: 1500px;
}

.empty {
  position: relative;
  z-index: 1;
  padding: var(--token-space-2xl);
  font-family: var(--token-font-ui);
}

/* Clear-all sits in the card's bottom-right corner (inside the scaled card,
 * so it scales with everything else) instead of floating over the top-right
 * content. */
.footer {
  display: flex;
  justify-content: flex-end;
}

.navButton,
.clearButton {
  min-height: var(--token-touch-min);
  padding: var(--token-space-sm) var(--token-space-lg);
  border-radius: var(--token-radius-pill);
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.35);
  color: var(--token-text-primary);
  backdrop-filter: blur(18px) saturate(160%);
  -webkit-backdrop-filter: blur(18px) saturate(160%);
  font-family: inherit;
  cursor: pointer;
}

.clearButton {
  margin-left: auto;
}

.card {
  background: rgba(255, 250, 240, 0.45);
  backdrop-filter: blur(22px) saturate(160%);
  -webkit-backdrop-filter: blur(22px) saturate(160%);
  border: 1.5px solid var(--token-accent);
  border-radius: var(--token-radius-card);
  padding: var(--token-space-lg);
  box-shadow:
    var(--token-shadow-card),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
  /* Bumped down from 1700 → 1650 (25px tighter on each side) per
   * Sarah's note that the card felt too wide. */
  max-width: 1650px;
  /* No `margin: 0 auto`: when the fixed-width card is larger than the page
   * (small viewports, pre-scale) auto margins collapse to 0 and left-align it,
   * which then scales off-centre. Let the parent's align-items: center handle
   * centering so the scaled card stays put. */
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--token-space-xl);
  /* Fit-to-height scale (see Number.tsx / useFitScale) shrinks the card to the
   * live safe box when it's too tall; scale toward the centre so it stays
   * centered in the page. */
  transform-origin: center center;
}

/* Two equal columns. Used twice: top row pairs Number modeling with
 * Currency, bottom row pairs Expanded-form + Neighbors with Odd/Even. */
.twoCol {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--token-space-xl);
}

.col {
  display: flex;
  flex-direction: column;
  gap: var(--token-space-md);
  min-width: 0;
}

/* Inside the 2-col card the dividers between sections become double walls
 * — drop the bottom border on the last child of each column. */
.col > :last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}
